import { useSearchParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
} from '@src/design-system/dialog';
import ViewUniversityModal from '../../components/view-university-moal';
import universitiesApi from '../../services/universities-api';

export function ViewUniversityDialogFromUrl() {
  const [searchParams, setSearchParams] = useSearchParams();
  const universityId = searchParams.get('view');

  const { data: university, isLoading } = universitiesApi.useFetchOne(
    { id: universityId ? Number(universityId) : null },
    { enabled: !!universityId }
  );

  const isOpen = !!universityId && !!university && !isLoading;

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('view');
      setSearchParams(newSearchParams);
    }
  };

  if (!universityId || isLoading || !university) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-[600px] bg-primary-30 overflow-hidden">
        <ViewUniversityModal university={university} />
      </DialogContent>
    </Dialog>
  );
}
